import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseButtonComponent } from '@d-components/button/button.component';
import { BaseFormComponent } from './form.component';
import { FormConfig } from './form.interface';

@Component({
  selector: 'app-form-array-item',
  templateUrl: './form-array-item.component.html',
  standalone: true,
  imports: [BaseButtonComponent, BaseFormComponent],
})
export class FormArrayItemComponent {
  @Input() removeBtnLabel!: string;
  @Input() addBtnLabel!: string;
  @Input() formConfig!: FormConfig[];
  @Output() addForm = new EventEmitter();
  @Output() removeForm = new EventEmitter();

  handleAddForm() {
    this.addForm.emit();
  }

  handleRemoveForm() {
    this.removeForm.emit();
  }
}
